import axiosInstance from 'common/js/axios-service'

export async function getNewsKey(params) {
  return axiosInstance.request({
    url: '/edu/news_key.json',
    params
  })
}
